module.exports = __webpack_public_path__ + "img/le-lodge-park-megeve.a8ad6b98.jpg";